<template>
  <div>
    <base-list-management ref="baseListManagement" :configData="configData">
      <div slot="custom-operate">
        <el-button type="primary" @click="showAuthDialog">新增印章授权</el-button>
        <el-button type="primary" v-if="showAddPurchaseBtn" @click="showPurchaseDialog">采购份额</el-button>
      </div>
    </base-list-management>
    <authDialog ref="authDialogRef" @closeAuthDialog="reloadList" />
    <purchaseDialog ref="purchaseDialogRef" />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { updateContractOrgState } from '@/api/domain/organize'
import configData from './config'
import authDialog from '../authDialog'
import purchaseDialog from '../purchaseDialog'

export default {
  name: 'eSignList',
  components: { authDialog, purchaseDialog },
  data() {
    return {
      configData: configData.call(this),
    }
  },
  methods: {
    // ./config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    showAuth(row) {
      this.$refs.authDialogRef.showDialog(row)
    },
    // ./config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    detailList(row) {
      this.$router.push({ name: 'chargeRecord', query: { orgId: row.orgId } })
    },
    // ./config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    handleDisable(row) {
      this.$confirm('停用后将无法进行线上签约，请确认。', '停用线上签约', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async () => {
          this.updateContractState(row)
        })
        .catch(() => null)
    },
    // ./config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    purchaseRecord(row) {
      this.$router.push({ name: 'purchaseRecordList', query: { orgName: row.orgName } })
    },
    // ./config.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    async handleEnable(row) {
      this.updateContractState(row)
    },
    async updateContractState(row) {
      const { code } = await updateContractOrgState({
        orgId: row.orgId,
        state: row.state === 0 ? 1 : 0,
      })

      if (code === 1) {
        this.$message.success(`${row.state === 0 ? '启用' : '停用'}成功`)
        this.$refs.baseListManagement.searchForm()
      }
    },
    showAuthDialog() {
      this.$refs.authDialogRef.showDialog()
    },
    showPurchaseDialog() {
      this.$refs.purchaseDialogRef.showDialog()
    },
    reloadList() {
      this.$refs.baseListManagement.searchForm()
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleRenewal(row) {
      this.$refs.authDialogRef.showDialog({
        orgName: row.orgName,
        orgIdCardNum: row.orgIdCardNum,
        orgId: row.orgId,
        disabled: false,
        reNew: 1,
      })
    },
  },
  computed: {
    showAddPurchaseBtn() {
      return this.judgePermission('add_purchase_btn')
    },
  },
}
</script>
<style lang="scss" scoped>
.preview-img {
  max-height: 300px;
  max-height: 300px;
}
</style>
